import styled from "styled-components";
import { COLOUR_CONSTANT } from "../../../utils/contants";

export const WorkScheduleStyled = styled.div`
  .label {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 8px;
  }

  .fields {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    max-width: calc(5 * (120px + 8px));

    fieldset {
      border: none !important;
    }

    .width {
      width: 80px;
      border: 1px solid ${COLOUR_CONSTANT.theme.dark};
      border-radius: 5px;
      height: 36px;
      display: flex;
      flex-direction: column;
      transition: 0.3s ease-in-out;
      position: relative;

      .day-label {
        height: 14px;
        background-color: ${COLOUR_CONSTANT.theme.purple.medium};
        display: flex;
        align-items: center;
        justify-content: center;
        border-top-right-radius: 4px;
        border-top-left-radius: 4px;
      }
    }

    .input-field {
      margin: 0px;

      .MuiInputBase-root {
        border-radius: 0px;
        height: 20px;
        padding: 8px !important;
      }
    }
  }

  .error {
    font-size: 11px;
    color: #d32f2f;
  }

  .MuiInputBase-root .MuiInputBase-input {
    text-align: center;
    padding-left: 0 !important;
  }
`;
